import { React, useState, useEffect, useRef, useContext } from "react";
import Button from "@mui/material/Button";
import axios from "axios";
import { AppContext } from '../../../AppStore';
import GridNoRow from '../../../common/GridNoRow';
import { DataGrid } from '@mui/x-data-grid';
import PCSelectModal from "../PCSelectModal";

function UserSelectModal({ title, onClose, handleUserClick }) {
  const appStore = useContext(AppContext);
  const searchRef = useRef(null);
  const [keyword, setKeyword] = useState('');
  const [rows, setRows] = useState([]);
  const [columns, setColumns] = useState([]);
  const [columnVisibilityModel, setColumnVisibilityModel] = useState({
    id: false,
    user_workplace_id: false,
    dept_id: false,
    position: false,
    duty: false,
    user_status: false,
    user_name: true,
    user_status_name: true,
    emp_no: true,
    dept_name: true,
    position_name: true,
    duty_name: true,
    user_phone: false
  });

  useEffect(() => {
    // Mount 될때만 실행된다.
    handleSetting();
    searchRef.current.focus();
    handleView();

    setColumnVisibilityModel({
      id: false,
      user_workplace_id: false,
      dept_id: false,
      position: false,
      duty: false,
      user_status: false,
      user_name: true,
      user_status_name: true,
      emp_no: true,
      dept_name: true,
      position_name: true,
      duty_name: true,
      user_phone: false
    });
  }, []);


  useEffect(() => {
    //렌더링 될 때 마다 실행된다.
  });

  const onSubmitSearch = (e) => {
    //입력 검색어는 Enter로 조회.
    if (e.key === "Enter") {
      handleView();
    }
  };
  
  const handleSetting = () => {
    setColumns([
        { field: 'id', headerName: 'user_id', width: 0, headerAlign: 'center' },
        { field: 'user_workplace_id', headerName: 'user_workplace_id', width: 0, headerAlign: 'center' },
        { field: 'dept_id', headerName: 'dept_id', width: 0, headerAlign: 'center' },
        { field: 'position', headerName: 'position', width: 0, headerAlign: 'center' },
        { field: 'duty', headerName: 'duty', width: 0, headerAlign: 'center' },
        { field: 'user_status', headerName: 'user_status', width: 0, headerAlign: 'center' },
        { field: 'user_name', headerName: '이름', width: 150, headerAlign: 'center' },
        { field: 'user_status_name', headerName: '상태', width: 80, headerAlign: 'center', align:'center' },
        { field: 'emp_no', headerName: '사번', width: 120, headerAlign: 'center', align:'center' },
        { field: 'dept_name', headerName: '부서', width: 120, headerAlign: 'center', align:'center' },
        { field: 'position_name', headerName: '직위', width: 120, headerAlign: 'center', align:'center' },
        { field: 'duty_name', headerName: '직책', width: 120, headerAlign: 'center', align:'center' },
        { field: 'user_phone', headerName: '연락처', width: 0, headerAlign: 'center', align:'center' },
    ]);
  }

  const handleView = () => {
    axios.get('/api/SelectCommon/UserList',
        {
        params : {
          keyword: keyword
        }
      },
      { withCredentials: true }
    )
    .then((response) => {
        
        var array = response.data.map((item, index) => ({
            id: item.user_id,
            user_workplace_id: item.user_workplace_id,
            dept_id: item.dept_id,
            position: item.position,
            duty: item.duty,
            user_status: item.user_status,
            user_name: item.user_name,
            user_status_name: item.user_status_name,
            emp_no: item.emp_no,
            dept_name: item.dept_name,
            position_name: item.position_name,
            duty_name: item.duty_name,
            user_phone: item.user_phone
        }));
        setRows(array);
        
    })
    .catch((error) => {
        appStore.capture();
    });
  };

  const handleRowClick = (params) => {
    //부모로 연결된 클릭 이벤트 부모에 handleUserClick 이벤트 만들어 놓아야함.
    handleUserClick(params.row);
    onClose?.();
  };

  const handleDelete = () => {
    handleUserClick({
      id: '',
      user_workplace_id: '',
      dept_id: '',
      position: '',
      duty: '',
      user_status: '',
      user_name: '',
      user_status_name: '',
      emp_no: '',
      dept_name: '',
      position_name: '',
      duty_name: '',
      user_phone: ''
    });
    onClose?.();
  };

  return (
    <PCSelectModal onClose={onClose} title={title}>
        <div className="modal" style={{ maxHeight : '435px' }}>
          <table className="SelectModalTABLE">
            <tbody>
            <tr>
              <td className="SelectModalTD" colSpan={2} style={ { padding: '5px' } }>
                <div className="modal_filed_input" style={ { width: 'calc(100% - 190px)', float: 'left' } }>
                  <input type="text" placeholder="검색" value={keyword} name="keyword" onChange={(e) => setKeyword(e.target.value) } onKeyPress={onSubmitSearch} ref={searchRef} autoComplete="off" />
                </div>
                
                <div className="modal_filed_input" style={ { float: 'right' } }>
                  <Button 
                    onClick={handleView}
                    className="btn-p btn-m"
                    sx={{  
                        m: 1, 
                        fontSize: 12, 
                        color: "white", 
                        borderColor: "#3D63AE", 
                        backgroundColor: "#3D63AE",
                        margin: '0px',
                        ":hover": { boxShadow: "2px 2px 2px #3D63AE" , backgroundColor: "#3D63AE", borderColor: "#3D63AE"}
                    }} 
                    variant="outlined">
                    조회
                  </Button>
                </div>
                <div className="modal_filed_input" style={ { float: 'right', paddingRight: '8px' } }>
                  <Button 
                    onClick={handleDelete}
                    className="btn-p btn-m"
                    sx={{  
                        m: 1, 
                        fontSize: 12, 
                        color: "white", 
                        borderColor: "#FF3636", 
                        backgroundColor: "#FF3636",
                        margin: '0px',
                        ":hover": { boxShadow: "2px 2px 2px #FF3636" , backgroundColor: "#FF3636", borderColor: "#FF3636"}
                    }} 
                    variant="outlined">
                    삭제
                  </Button>
                </div>
              </td>
            </tr>
            <tr>
              <td className="SelectModalTD" colSpan={2}>
                <div style={{ padding: '5px', height: '300px' }}>
                  <DataGrid
                    rows={rows}
                    columns={columns}
                    columnVisibilityModel={columnVisibilityModel}
                    onProcessRowUpdateError={(error) => error}
                    AlternatingRowBackground="LavenderBlush"
                    rowsPerPageOptions={[20, 50, 100]}
                    onRowClick={handleRowClick}
                    initialState={{ 
                        density: 'compact'
                    }}
                    slots={{
                        noRowsOverlay: GridNoRow,
                    }}
                    sx={{
                      cursor: "pointer"
                    }}      
                    disableColumnSorting 
                  />
                </div>
              </td>
            </tr>
            <tr>
              <td className="SelectModalTD" colSpan={2}>
                <div className="select_modal_action">
                  <div className="select_modal_button">
                    <Button 
                      onClick={()=> { onClose?.(); }}
                      className="btn-p btn-m"
                      sx={{  
                          m: 1, 
                          fontSize: 12, 
                          color: "white", 
                          borderColor: "#808080", 
                          backgroundColor: "#808080",
                          ":hover": { boxShadow: "2px 2px 2px #808080" , backgroundColor: "#808080", borderColor: "#808080"}
                      }} 
                      variant="outlined">
                      닫기
                    </Button>
                  </div>
                </div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
    </PCSelectModal>
  );
}

export default UserSelectModal;